import { PAGEOBJECTTYPE } from "./pageobject";
import { PageObjectText } from "./pageobjecttext";
import { ObjectProperty, OBJECTPROPERTYTYPE } from "./objectproperty";

export class PageObjectInput extends PageObjectText {
  inputType: string;
  borderColor: string;

  constructor(obj: PageObjectInput = null, style: string = "") {
    super(obj);
    this._type = PAGEOBJECTTYPE.Input;

    if (obj == null) {
      this.inputType = "text";
      this.borderColor = "#CCC";
    } else {
      this.inputType = obj.inputType;
      this.borderColor = obj.borderColor;
    }
  }

  getPropertiesList(): ObjectProperty[] {
    let list = super.getPropertiesList();
    for (let i = 0; i < list.length; i++) {
      if (list[i].name == "Line Height") {
        list[i].editType = OBJECTPROPERTYTYPE.Text;
        list.splice(i, 1);
        break;
      }
    }

    let inputType = new ObjectProperty("Input Type", OBJECTPROPERTYTYPE.List);
    inputType.addOption("text", "Text");
    inputType.addOption("multi-line", "Multi-Line");
    inputType.addOption("password", "Password");
    list.push(inputType);
    list.push(new ObjectProperty("Border Color", OBJECTPROPERTYTYPE.Text));

    return list;
  }

  getPropertyValue(name: string): any {
    if (name == "Input Type") {
      return this.inputType;
    } else if (name == "Border Color") {
      return this.borderColor;
    }

    return super.getPropertyValue(name);
  }

  setPropertyValue(name: string, value: any, style: string): void {
    super.setPropertyValue(name, value, style);

    if (name == "Input Type") {
      this.inputType = value;
    } else if (name == "Border Color") {
      this.borderColor = value;
    }
  }
}
